import * as App$dApp from "../App.App/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Halogen$dAff$dUtil from "../Halogen.Aff.Util/index.js";
import * as Halogen$dVDom$dDriver from "../Halogen.VDom.Driver/index.js";
const main = /* #__PURE__ */ Halogen$dAff$dUtil.runHalogenAff(/* #__PURE__ */ Effect$dAff._bind(Halogen$dAff$dUtil.awaitBody)(body => Halogen$dVDom$dDriver.runUI(App$dApp.component)()(body)));
export {main};
